module.exports = __webpack_public_path__ + "img/service-supply.7dd2840.webp";